import { AppPreference } from '../config/AppPreferences';

const analyticsEnabled = process.env.NODE_ENV === 'production';

// On garde ta vérification des cookies !
const analyticsIsAvailable = () => {
  return analyticsEnabled && localStorage.getItem(AppPreference.CookiesConsent) === 'true';
}

// Nouvelle fonction qui utilise le script gtag qu'on a mis dans index.html
const trackEvent = (eventName, eventParams) => {
  if (!analyticsEnabled) {
    // Mode DEV (npm start) : on affiche dans la console pour vérifier
    console.log(`[GA4 TEST] ${eventName}`, eventParams);
    return;
  }

  // Mode PROD : si consentement OK et script chargé, on envoie à GA4
  if (analyticsIsAvailable() && typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};

export const Init = () => {
  // Plus besoin d'initialiser Firebase ici, le script dans index.html fait le travail
}

// --- SUIVI DES AUDIOS ---

export const PoiAudioPlay = (item) => {
  trackEvent("ecoute_audio", item);
}

export const PoiAudioPause = (item) => {
  trackEvent("pause_audio", item);
}

export const PoiAudioListened = (item) => {
  trackEvent("fin_audio", item);
}

// --- SUIVI DES PARCOURS (NOUVEAU) ---

export const TourChosen = (tour) => {
  trackEvent('choix_parcours', {
    type_parcours: tour.id, // Ex: "1" (complet) ou "2" (court)
    nom_parcours: tour.name,
    langue: tour.langue
  });
};